module.exports = __webpack_public_path__ + "static/media/create.5c3e9d28.png";